import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableError = loadable(() => import('./Error'), {
  fallback: <LoadingScreen />,
});

export default LoadableError;
